import React from 'react';
import { CalendarDays } from 'lucide-react';

// day: due day of month; months: applicable months (1-12), empty = every month
const COMPLIANCES = [
  { day: 7, name: 'TDS/TCS Payment', desc: 'Previous month ka TDS deposit', months: [] },
  { day: 11, name: 'GST GSTR-1', desc: 'Monthly outward supplies return', months: [] },
  { day: 13, name: 'GSTR-1 (QRMP IFF)', desc: 'Quarterly filers invoice facility', months: [1, 4, 7, 10] },
  { day: 15, name: 'PF Payment (EPF)', desc: 'Employee Provident Fund deposit', months: [] },
  { day: 15, name: 'ESIC Payment', desc: 'ESI contribution deposit', months: [] },
  { day: 15, name: 'Advance Tax', desc: 'Quarterly installment', months: [6, 9, 12, 3] },
  { day: 15, name: 'TDS Return (Quarterly)', desc: 'Form 24Q/26Q filing', months: [7, 10, 1, 5] },
  { day: 20, name: 'GST GSTR-3B', desc: 'Monthly summary return & tax payment', months: [] },
  { day: 25, name: 'PF Return (ECR)', desc: 'Monthly PF return', months: [] },
  { day: 30, name: 'Professional Tax', desc: 'PT payment (state-wise)', months: [] },
  { day: 30, name: 'ROC Annual Filing (AOC-4)', desc: 'Company financial statements', months: [10] },
  { day: 30, name: 'LLP Form 11', desc: 'LLP Annual Return', months: [5] },
  { day: 31, name: 'Income Tax Return', desc: 'ITR filing (non-audit)', months: [7] },
  { day: 29, name: 'ROC MGT-7', desc: 'Company Annual Return', months: [11] },
];

export const ComplianceCalendar = () => {
  const now = new Date();
  const month = now.getMonth() + 1;
  const today = now.getDate();
  const monthName = now.toLocaleString('en-IN', { month: 'long', year: 'numeric' });
  const daysInMonth = new Date(now.getFullYear(), month, 0).getDate();

  const items = COMPLIANCES
    .filter((c) => c.months.length === 0 || c.months.includes(month))
    .map((c) => ({ ...c, day: Math.min(c.day, daysInMonth) }))
    .sort((a, b) => a.day - b.day);

  const statusOf = (day) => {
    if (day < today) return { label: '🟢 Done / Passed', cls: 'bg-emerald-50 border-emerald-200', badge: 'bg-emerald-100 text-emerald-700' };
    if (day - today <= 5) return { label: '🔴 High Priority', cls: 'bg-red-50 border-red-200', badge: 'bg-red-100 text-red-600' };
    return { label: '🟡 Upcoming', cls: 'bg-amber-50 border-amber-200', badge: 'bg-amber-100 text-amber-700' };
  };

  return (
    <section className="py-16 bg-white" data-testid="compliance-calendar-section">
      <div className="container mx-auto px-4">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 bg-[#0A2463]/5 text-[#0A2463] px-4 py-1.5 rounded-full text-sm font-semibold mb-3">
            <CalendarDays size={16} /> Compliance Calendar
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-[#0A2463]">📅 {monthName} — Important Due Dates</h2>
          <p className="text-gray-500 mt-2 text-sm">Miss na karein! Har month automatic update hota hai</p>
          <div className="flex justify-center gap-4 mt-3 text-xs font-semibold">
            <span className="text-red-600">🔴 High Priority (5 din ke andar)</span>
            <span className="text-amber-600">🟡 Upcoming</span>
            <span className="text-emerald-600">🟢 Passed</span>
          </div>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 max-w-6xl mx-auto">
          {items.map((c, i) => {
            const st = statusOf(c.day);
            return (
              <div key={i} data-testid={`compliance-item-${i}`} className={`rounded-2xl border-2 p-4 hover:shadow-lg transition-shadow ${st.cls}`}>
                <div className="flex items-start justify-between gap-2">
                  <div className="bg-white rounded-xl shadow-sm px-3 py-1.5 text-center border border-gray-100">
                    <p className="text-xl font-bold text-[#0A2463] leading-none">{c.day}</p>
                    <p className="text-[9px] text-gray-500 font-semibold uppercase">{now.toLocaleString('en-IN', { month: 'short' })}</p>
                  </div>
                  <span className={`text-[10px] font-bold px-2 py-1 rounded-full ${st.badge}`}>{st.label}</span>
                </div>
                <h3 className="text-sm font-bold text-gray-800 mt-3">{c.name}</h3>
                <p className="text-xs text-gray-500 mt-0.5">{c.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ComplianceCalendar;
